import BaseService from '@/services/base.service';
const CURRENCY_CODE = process.env.VUE_APP_CURRENCY_CODE;

class ToolService extends BaseService {
    formatAmount(amount: number) {

        const final = CURRENCY_CODE + " " + amount.toFixed(2);
        return final;
    }

    getDrawDate() {
        const today = new Date();
        today.setDate(today.getDate() + (5 - 1 - today.getDay() + 7) % 7 + 1);
        return today.toDateString() + " 20:25 ";
    }
}

export default new ToolService();